<template>
  <div class="name">{{ convertedName }}</div>
</template>

<script>
import * as products from './productName';

export default {
  name: 'Product',
  props: {
    vendor: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    // type: {
    //   type: String,
    //   default: 'long',
    // },
    short: Boolean,
  },
  computed: {
    type() {
      if (this.short) {
        return 'short';
      }
      return 'long';
    },
    convertedName() {
      const x = Object.keys(products[this.type]).filter(key => {
        return key === this.name;
      });

      if (x.length === 0) return this.name;
      return products[this.type][x];
    },
  },
};
</script>

<style scoped>
.name {
  display: inline-block;
}
</style>
